<script lang="ts">
  import CollateralScroller from './CollateralScroller.svelte'
  import ButaneScroller from './ButaneScroller.svelte'
</script>

<div class="mx-auto max-w-[1700px]">
  <section>
    <ButaneScroller />
    <CollateralScroller />
  </section>
</div>
